import BorderedSection from './BorderedSection'
import PaddedText from './PaddedText'

const DateHeader = ({ children, ...props }) => (
  <BorderedSection
    flex={1}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      backgroundColor: theme => theme.palette.secondary[80].main,
    }}
    {...props}
  >
    <PaddedText
      typographyProps={{
        sx: { wordBreak: 'break-all', padding: 0, color: theme => theme.palette.other.white.main },
      }}
    >
      {children}
    </PaddedText>
  </BorderedSection>
)

export default DateHeader
